<form [formGroup]="form" class="flex flex-col justify-center items-center space-y-4">
  
  <!-- Toggle para habilitar débito automático -->
  <div class="w-full space-y-3">
    <div class="w-full mb-4">
      <div class="flex justify-between items-center w-full pr-2 mb-2">
        <label class="text-label">
          ¿Desea habilitar el débito automático?
        </label>
        <app-lock-toggle
          [unlocked]="automaticDebitUnlocked"
          (pressed)="toggleAutomaticDebitLock()"
        ></app-lock-toggle>
      </div>
      
      <div class="flex flex-col space-y-2">
        <div class="flex items-center mt-2">
          <input
            formControlName="automaticDebit"
            class="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500"
            type="radio"
            id="automaticDebitYes"
            name="automaticDebit" 
            [value]="true"
            [disabled]="isCheckData || !automaticDebitUnlocked"
          />
          <label for="automaticDebitYes" class="ml-2 block text-sm text-gray-900">Sí</label>
        </div>
        
        <div class="flex items-center">
          <input
            formControlName="automaticDebit"
            class="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500"
            type="radio"
            id="automaticDebitNo"
            name="automaticDebit"
            [value]="false"
            [disabled]="isCheckData || !automaticDebitUnlocked"
          />
          <label for="automaticDebitNo" class="ml-2 block text-sm text-gray-900">No</label>
        </div>
      </div>
      @if(form.get('automaticDebit')?.invalid && (isTimeout || form.get('automaticDebit')?.touched) && !isCheckData){
          <div class="text-red-500 text-sm mt-1">
            Por favor selecciona una opción.
          </div>
      }
    </div>

    <!-- Dato anterior para automaticDebit (solo en modo check) -->
    @if (isCheckData && dataLastOnboarding && dataLastOnboarding['automaticDebit'] !== undefined) {
      <div class="flex items-center justify-between px-3 py-2 bg-base-200/50 rounded-lg border-l-2 border-primary shadow-xl">
        <div class="flex items-center gap-2">
          <span class="text-xs text-label">Débito automático:</span>
          <span class="font-medium text-base-content">
            {{ dataLastOnboarding['automaticDebit'] ? 'Sí' : 'No' }}
          </span>
        </div>
      </div>
    }
  </div>

  <!-- Sección de detalles de débito (solo se muestra si seleccionó Sí o si hay datos en modo check) -->
  @if (shouldShowDebitDetails()) {
    
    <!-- Selector para Tipo de Débito -->
    <div class="w-full space-y-3">
      <app-selected 
        class="w-full block"
        [config]="dataSelected().at(0)"
        (selectValue)="handleValue($event)"
      ></app-selected>

      <!-- Dato anterior para debitType -->
      @if (isCheckData && dataLastOnboarding && dataLastOnboarding['debitType'] !== undefined) {
        <div class="flex items-center justify-between px-3 py-2 bg-base-200/50 rounded-lg border-l-2 border-primary shadow-xl">
          <div class="flex items-center gap-2">
            <span class="text-xs text-label">Tipo de débito anterior:</span>
            <span class="font-medium text-base-content">
              {{ dataLastOnboarding['debitType'] }}
            </span>
          </div>
        </div>
      }
    </div>

    <!-- Campos para Débito Externo (se muestran si es EXTERNO o si hay datos en modo check) -->
    @if (shouldShowExternalDebitFields()) {
      
      <!-- Selector para Banco -->
      <div class="w-full space-y-3">
        <app-selected 
          class="w-full block"
          [config]="dataSelected().at(1)"
          (selectValue)="handleValue($event)"
        ></app-selected>

        <!-- Dato anterior para bank -->
        @if (isCheckData && dataLastOnboarding && dataLastOnboarding['bank'] !== undefined) {
          <div class="flex items-center justify-between px-3 py-2 bg-base-200/50 rounded-lg border-l-2 border-primary shadow-xl">
            <div class="flex items-center gap-2">
              <span class="text-xs text-label">Banco anterior:</span>
              <span class="font-medium text-base-content">
                {{ dataLastOnboarding['bank'] }}
              </span>
            </div>
          </div>
        }
      </div>

      <!-- Input para Número de Cuenta -->
      @for (config of dataInputs(); track $index) {
        @if (config.formName === 'accountNumber') {
          <div class="w-full space-y-3">
            <app-input
              class="w-full block"
              [config]="config"
              (submitValue)="handleValue($event)"
            ></app-input>

            <!-- Dato anterior para accountNumber -->
            @if (isCheckData && dataLastOnboarding && dataLastOnboarding['accountNumber'] !== undefined) {
              <div class="flex items-center justify-between px-3 py-2 bg-base-200/50 rounded-lg border-l-2 border-primary shadow-xl">
                <div class="flex items-center gap-2">
                  <span class="text-xs text-label">Cuenta anterior:</span>
                  <span class="font-medium text-base-content">
                    {{ dataLastOnboarding['accountNumber'] }}
                  </span>
                </div>
              </div>
            }
          </div>
        }
      }

      <!-- Selector para Tipo de Cuenta -->
      <div class="w-full space-y-3">
        <app-selected 
          class="w-full block"
          [config]="dataSelected().at(2)"
          (selectValue)="handleValue($event)"
        ></app-selected>

        <!-- Dato anterior para accountType -->
        @if (isCheckData && dataLastOnboarding && dataLastOnboarding['accountType'] !== undefined) {
          <div class="flex items-center justify-between px-3 py-2 bg-base-200/50 rounded-lg border-l-2 border-primary shadow-xl">
            <div class="flex items-center gap-2">
              <span class="text-xs text-label">Tipo de cuenta anterior:</span>
              <span class="font-medium text-base-content">
                {{ dataLastOnboarding['accountType'] }}
              </span>
            </div>
          </div>
        }
      </div>

      <!-- Input para Día Débito -->
      @for (config of dataInputs(); track $index) {
        @if (config.formName === 'debitDay') {
          <div class="w-full space-y-3">
            <app-input
              class="w-full block"
              [config]="config"
              (submitValue)="handleValue($event)"
            ></app-input>

            <!-- Dato anterior para debitDay -->
            @if (isCheckData && dataLastOnboarding && dataLastOnboarding['debitDay'] !== undefined) {
              <div class="flex items-center justify-between px-3 py-2 bg-base-200/50 rounded-lg border-l-2 border-primary shadow-xl">
                <div class="flex items-center gap-2">
                  <span class="text-xs text-label">Día de débito anterior:</span>
                  <span class="font-medium text-base-content">
                    {{ dataLastOnboarding['debitDay'] }}
                  </span>
                </div>
              </div>
            }
          </div>
        }
      }
    }

    <!-- Si en modo check hay datos de débito externo pero el tipo no es EXTERNO, mostramos un resumen -->
    @if (isCheckData && dataLastOnboarding && 
         dataLastOnboarding['automaticDebit'] === true && 
         dataLastOnboarding['debitType'] === 'EXTERNO' && 
         form.get('debitType')?.value !== 'EXTERNO') {
      <div class="w-full p-4 bg-base-200 rounded-lg border-l-2 border-warning shadow-xl">
        <h4 class="text-sm font-semibold text-label mb-2 flex items-center gap-2">
          <span class="text-warning">📋</span> Datos de débito externo registrados:
        </h4>
        <div class="space-y-2 text-sm">
          @if (dataLastOnboarding['bank']) {
            <div class="flex justify-between">
              <span class="text-label">Banco:</span>
              <span class="font-medium">{{ dataLastOnboarding['bank'] }}</span>
            </div>
          }
          @if (dataLastOnboarding['accountNumber']) {
            <div class="flex justify-between">
              <span class="text-label">Cuenta:</span>
              <span class="font-medium">{{ dataLastOnboarding['accountNumber'] }}</span>
            </div>
          }
          @if (dataLastOnboarding['accountType']) {
            <div class="flex justify-between">
              <span class="text-label">Tipo de cuenta:</span>
              <span class="font-medium">{{ dataLastOnboarding['accountType'] }}</span>
            </div>
          }
          @if (dataLastOnboarding['debitDay']) {
            <div class="flex justify-between">
              <span class="text-label">Día de débito:</span>
              <span class="font-medium">{{ dataLastOnboarding['debitDay'] }}</span>
            </div>
          }
        </div>
      </div>
    }
  }
</form>